import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.scss';

export default class Accordian extends Component{

    static propTypes = {
        item: PropTypes.object,
        id: PropTypes.any,
        className: PropTypes.string,
    }

    constructor(props){
        super(props);
        this.state = {
            open: false,
            class: 'section'
        }
    }

    toggleAccordian = (id) => {
        //to make all other accordain close
        //document.querySelector(".section.open div[id^='_']").click();
        let { monthlyMusings } = this.props;
        let openedAccordian = document.querySelector(".section.open div[id^='_']");
        if(openedAccordian !== document.getElementById(id)) {
            openedAccordian && openedAccordian.click();
        }
        if(monthlyMusings){
            let scrollToElement = require('scroll-to-element');
            scrollToElement(document.getElementById(id.slice(1)), {
                offset: -150,
                ease: 'linear',
                duration: 100,

            });
            if((document.getElementById(id.slice(1)).className).includes("open")){
                document.getElementById(id.slice(1)).classList.remove("open");
                this.setState({
                    open: false,
                    class: "section"
                });
            } else {
                document.getElementById(id.slice(1)).classList.add("open");
                this.setState({
                    open: true,
                    class: "section open"
                });
            }
        }
        else if(this.state.open) {
            this.setState({
                open: false,
                class: "section"
            });
        }else{
            this.setState({
                open: true,
                class: "section open"
            });
        }
    }

    render(){
        let { item:{title,body,description,fileDescription, cautionTitle}, id, className, children , allowScroll, monthlyMusings, fromPublicCaution} = this.props;

        className = className ? 'accordian '+className : 'accordian';
         if(this.state.open && !allowScroll && !monthlyMusings){
            let scrollToElement = require('scroll-to-element');
            scrollToElement(document.getElementById(id), {
                // offset:-(document.getElementsByClassName('secondary-nav')[0].clientHeight+document.querySelectorAll('header')[0].clientHeight),
                offset: -185,
                ease: 'linear',
                duration: 100,

            });
        }

        return (
            <div className={className}>
                <div className={this.state.class} id={id}>
                    <button tabIndex="-1">toggle</button>
                    <div tabIndex="0" role="tablist" className="sectionhead" onClick={()=>this.toggleAccordian('_'+id)} id={'_'+id}
                    onKeyPress={()=>this.toggleAccordian('_'+id)} id={'_'+id}>{(fromPublicCaution ? cautionTitle : title)}</div>
                    <div className="articlewrap">
                    {children ? children : <div className="article"  dangerouslySetInnerHTML={{ __html: monthlyMusings ? description : (fromPublicCaution ? fileDescription : body) }} />}
                    </div>
                </div>
            </div>
        );
    }
}


